import { createTheme } from '@mui/material/styles';

const deepBlue = '#1f4fbf';
const accentOrange = '#f26b3a';
const softCream = '#fdf3e4';
const paper = '#fffaf2';
const ink = '#1c274c';
const gridLine = 'rgba(31, 79, 191, 0.08)';

const themeCardapio = createTheme({
  palette: {
    mode: 'light',
    primary: { main: deepBlue },
    secondary: { main: accentOrange },
    success: { main: '#2c9c6b' },
    background: { default: softCream, paper },
    text: { primary: ink, secondary: '#43516f' },
  },
  typography: {
    fontFamily: `'Playfair Display', 'DM Serif Display', Georgia, 'Times New Roman', serif`,
    h1: { fontWeight: 800, letterSpacing: 2, textTransform: 'uppercase' },
    h2: { fontWeight: 800, letterSpacing: 1.4, textTransform: 'uppercase' },
    h3: { fontWeight: 700, letterSpacing: 1 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    button: { textTransform: 'uppercase', fontWeight: 800, letterSpacing: '0.08em' },
  },
  shape: { borderRadius: 14 },
  shadows: [
    'none',
    '0 10px 24px rgba(28,39,76,0.12)',
    ...Array(23).fill('0 10px 24px rgba(28,39,76,0.1)'),
  ],
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: softCream,
          color: ink,
          backgroundImage: `
            linear-gradient(90deg, ${gridLine} 1px, transparent 1px),
            linear-gradient(180deg, ${gridLine} 1px, transparent 1px),
            radial-gradient(circle at 18% 12%, rgba(31, 79, 191, 0.08), transparent 36%),
            radial-gradient(circle at 82% 8%, rgba(242, 107, 58, 0.09), transparent 32%),
            linear-gradient(135deg, #fffaf2 0%, #f6e8d7 100%)
          `,
          backgroundSize: '78px 78px, 78px 78px, 100% 100%, 100% 100%, 100% 100%',
          backgroundBlendMode: 'normal, normal, multiply, multiply, normal',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 800,
          letterSpacing: '0.08em',
          boxShadow: '0 10px 24px rgba(31,79,191,0.14)',
        },
        containedPrimary: {
          backgroundColor: deepBlue,
          '&:hover': { backgroundColor: '#173c97' },
        },
        containedSecondary: {
          backgroundColor: accentOrange,
          color: '#fff',
          '&:hover': { backgroundColor: '#d95b2f' },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 18,
          backgroundImage: `linear-gradient(120deg, rgba(31,79,191,0.04), rgba(242,107,58,0.03))`,
          border: '1px solid rgba(28,39,76,0.08)',
          boxShadow: '0 16px 32px rgba(28,39,76,0.12)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 14,
            backgroundColor: '#fff9f1',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 12, fontWeight: 700, letterSpacing: '0.04em' },
      },
    },
  },
});

export default themeCardapio;
